<template>
  <div>
    <div class="row m-0">
      <div class="col-12 pl-md-3 my-3">
        <h3>Returns and Refund Policy</h3>
      </div>
      <div class="col-12 pl-3 my-3">
        <div class="row m-0">
          <!-- <div class="col-12 p-0 mb-3">
            <b></b>
          </div> -->
          <div class="col-12 p-0 mb-3">
            <p>Thanks for purchasing our products at modelonline.co.za</p>
            <p>We offer a full moneyback guarantee on all purchases made on our website but under certain conditions. Signing the courier delivery sheet means that you have examined the contents of your delivery and are satisfied with it, and in this instance no returns will be accepted. If the contents are damaged, please do not sign the delivery sheet but notify us and we will take it up with the courier. If youreceive the wrong goods, or an incorrect quantity, please do not sign the deliverysheet but contact us immediately and we will amend the error at our cost.</p>
            <p>Please report any concern to <br/>
            <a href="mailto:viccy.baker@gmail.com" target="_blank">viccy.baker@gmail.com</a><br/>
            <a href="tel:+27823851071" target="_blank">+27823851071</a></p>
          </div>
          <div class="col-12 p-0 mb-3">
            <b>FAQ</b>
          </div>
          <div class="col-12 p-0">
            <p>
              <b>Where is Model Bottle Store situated?</b><br/>
              In Pierneef Boulevard, Meyerton.
            </p>
            <p>
              <b>Which credit and debit cards do you accept?</b><br/>
              Master and Visa cards
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['position'],
  data () {
    return {
      loaderSize: '50px'
    }
  },
  metaInfo () {
    return {
      title: 'The Hoods - Home',
      meta: [
        { name: 'description', content: 'Shop local, online.' },
        {
          property: 'fb:app_id',
          content: '2744358572336800'
        },
        { property: 'og:title', content: 'The Hoods' },
        {
          property: 'og:description',
          content: 'Shop local, online.'
        },
        { property: 'og:type', content: 'website' },
        {
          property: 'og:image',
          content: '/thehoods_large.png/'
        },
        {
          property: 'og:url',
          content: 'https://thehoods.app/'
        }
      ]
    }
  }
}
</script>

<style>
.small_text {
  font-size: 0.8rem;
  line-height: 1;
}
.border_bottom {
  border-bottom: 1px solid var(--light-color-off);
}
.dark-mode .border_bottom {
  border-bottom: 1px solid var(--light-color-01);
}
.small_text .truncate {
    word-wrap: break-word;
    overflow-y: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    height: 2;
  }
.small_text .form-control {
  font-size: 0.8rem;
}
.category_menu {
  height: 50px;
  position: sticky;
  top: 80px;
  z-index: 9;
}
.bg_color {
  border-top: 1px solid var(--dark-color-off);
  margin-left: -1px;
}
.dark-mode .bg_color {
  border-top: 1px solid var(--light-color-off);
  border-left: 1px solid var(--dark-color-off)
}
.overflow_x  {
  overflow-x: auto;
}

@media (min-width: 768px) {
  .category_menu {
    top: 50px;
  }
  .sidebar_cart {
    position: sticky;
    top: 120px;
    z-index: 9;
    bottom: inherit;
    width: 100%;
    max-height: calc(100vh - 120px);
  }
}
</style>
